import requests from "./httpService";

const MachineIntegrationService = {
    getMachines(companyId) {
        return requests.get(`/machine-integration/get?company_id=${companyId}`);
    },
    createMachine(body) {
        return requests.post(`/machine-integration/create`, body);
    },
    updateMachine(id, body) {
        return requests.put(`/machine-integration/update/${id}`, body);
    },
    deleteMachine(id, companyId) {
        return requests.delete(`/machine-integration/delete/${id}?company_id=${companyId}`);
    },
    statusUpdate(id) {
        return requests.get(`/machine-integration/statusupdate/${id}`);
    },
    testConnection(id) {
        return requests.get(`/machine-integration/test-connection/${id}`);
    },
};

export default MachineIntegrationService;
